import { Button, Icon, Popover, Tooltip } from '@blueprintjs/core';
import { POPOVER_DISMISS } from '@blueprintjs/core/lib/esnext/common/classes';
import { useGlobalState } from 'Data/context/GlobalState';
import YearConfig from 'Pages/Configuration/YearConfig';
import PropTypes from 'prop-types';
import styles from './FilterIndicator.module.css';

const FilterIndicator = () => {
  const [globalState] = useGlobalState();
  let label =
    globalState.fiscalYear?.length > 0
      ? `(FY${
          globalState.fiscalYear?.length > 1 ? "'s:" : ':'
        } ${globalState.fiscalYear.join(', ')})`
      : '(Showing all)';

  let tooltipContent = (
    <div
      style={{
        fontSize: 'small',
        padding: 4,
        maxWidth: 400,
        whiteSpace: 'pre-wrap',
      }}>
      {globalState.fiscalYear?.length > 0
        ? `BOS is currently configured to filter content to FY${
            globalState.fiscalYear?.length > 1 ? "'s" : ''
          } ${globalState.fiscalYear.join(
            ', ',
          )} only. To see other fiscal years, or to turn off this filter, click to update the filter.`
        : `BOS is currently showing all data. To filter by fiscal year, click to update the filter.`}
    </div>
  );

  const popoverBox = (
    <div style={{ padding: 20 }}>
      <Button
        small
        minimal
        intent='danger'
        className={[styles.close_popover_button, POPOVER_DISMISS]}
        icon={'cross'}
      />
      <YearConfig />
    </div>
  );

  return (
    <Popover content={popoverBox} placement={'bottom'} interactionKind='click'>
      <Tooltip content={tooltipContent} interactionKind={'hover-target'}>
        <span className={styles.label_box}>
          {label}
          <Icon icon={'small-info-sign'} />
        </span>
      </Tooltip>
    </Popover>
  );
};

FilterIndicator.propTypes = {
  label: PropTypes.string,
};

export default FilterIndicator;
